import type { ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';
export * from './project';

const request = httpUtil.accurate.request;
const prefix = 'v1/issues';

export const issueUserFilterApi = {
  /**
   * @description 获取当前用户的自定义筛选器
   */
  getAll(): ResponseType<any[]> {
    return request({
      url: prefix + '/userFilters',
      method: 'GET',
    });
  },

  /**
   * @description 创建自定义筛选器
   */
  create(data: any): ResponseType {
    return request({
      url: prefix + '/userFilter',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新自定义筛选器
   */
  update(id: number, data: any): ResponseType {
    return request({
      url: prefix + '/userFilter/' + id,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除自定义筛选器
   */
  del(id: number): ResponseType {
    return request({
      url: prefix + '/userFilter/' + id,
      method: 'DELETE',
    });
  },
};
